import classNames from 'classnames';

export const getClassNamesForEditable = (className, isEditable) => {
  return isEditable ? classNames(className, 'editable') : className;
};

export const getLinearGradient = (colors, direction = 'to bottom') => {
  // Return an empty string for invalid input:
  if (!colors || !colors.length) {
    return '';
  }

  // A gradient requires more than one color:
  if (colors.length < 2) {
    return colors[0];
  }

  // If two or more colors were passed, form the gradient:
  const entries = colors.map((color, index) => {
    const offset = (index / (colors.length - 1)) * 100;
    return `${color} ${offset}%`;
  });
  return `linear-gradient(${direction}, ${entries.join(', ')})`;
};
